<template lang="html">
  <section class="slider-instalaciones">
    <div class="container fixed-head">
      <h2 class="title-type -white">
        {{ $t('home.instalaciones.title') }}
      </h2>
    </div>
    <slick ref="slick" :options="slickOptions">
      <article class="slide" data="autoconsumo">
        <div class="slide-container row-between">
          <div class="contenedor-textos">
            <h2>
              <span class="-dark">{{ $t('home.instalaciones.facility') }}</span>
              <span class="-white">{{ $t('home.instalaciones.selfConsumption') }}</span>
            </h2>
          </div>
          <div class="contenedor-imagen">
            <h2 class="titulo-mvl">
              <span class="-dark">{{ $t('home.instalaciones.facility') }}</span>
              <span class="-white">{{ $t('home.instalaciones.selfConsumption') }}</span>
            </h2>
            <div class="contenedor-titulo row-center">
              <div class="info-principal">
                <h3 class="tipo-tarifa -white">
                  <span class="-white">
                    {{ $t('home.instalaciones.yourFacility') }}
                    <strong>{{ $t('home.instalaciones.from') }}</strong>
                  </span>
                </h3>
                <h4 class="precio" v-if="!!precios">
                  <strong>3.500</strong><span>€</span>
                </h4>
              </div>
              <div class="contenedor-botones row-center">
                <router-link :to="$t('enlaces.autoconsumo')" title="Ver más" class="btn -degree">
                  {{ $t('home.instalaciones.btnShowMore') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article class="slide" data="aerotermia">
        <div class="slide-container row-between">
          <div class="contenedor-textos">
            <h2>
              <span class="-dark">{{ $t('home.instalaciones.facility') }}</span>
              <span class="-white">{{ $t('home.instalaciones.aerotermia') }}</span>
            </h2>
          </div>
          <div class="contenedor-imagen">
            <h2 class="titulo-mvl">
              <span class="-dark">{{ $t('home.instalaciones.facility') }}</span>
              <span class="-white">{{ $t('home.instalaciones.aerotermia') }}</span>
            </h2>
            <div class="contenedor-titulo row-center">
              <div class="info-principal">
                <h3 class="tipo-tarifa -white">
                  <span class="-white">
                    {{ $t('home.instalaciones.yourFacility') }}
                    <strong>{{ $t('home.instalaciones.from') }}</strong>
                  </span>
                </h3>
                <h4 class="precio" v-if="!!precios">
                  <strong>8.000</strong><span>€</span>
                </h4>
              </div>
              <div class="contenedor-botones row-center">
                <router-link :to="$t('enlaces.aerotermia')" title="Ver más" class="btn -degree">
                  {{ $t('home.instalaciones.btnShowMore') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article class="slide" data="vehiculo-electrico">
        <div class="slide-container row-between">
          <div class="contenedor-textos">
            <h2>
              <span class="-dark">{{ $t('home.instalaciones.facility') }}</span>
              <span class="-white">{{ $t('home.instalaciones.electricVehicle') }}</span>
            </h2>
          </div>
          <div class="contenedor-imagen">
            <h2 class="titulo-mvl">
              <span class="-dark">{{ $t('home.instalaciones.facility') }}</span>
              <span class="-white">{{ $t('home.instalaciones.electricVehicle') }}</span>
            </h2>
            <div class="contenedor-titulo row-center">
              <div class="info-principal">
                <h3 class="tipo-tarifa -white">
                  <span class="-white">
                    {{ $t('home.instalaciones.yourFacility') }}
                    <strong>{{ $t('home.instalaciones.from') }}</strong>
                  </span>
                </h3>
                <h4 class="precio" v-if="!!precios">
                  <strong>1.200</strong><span>€</span>
                </h4>
              </div>
              <div class="contenedor-botones row-center">
                <router-link :to="$t('enlaces.coche_electrico')" title="Ver más" class="btn -degree">
                  {{ $t('home.instalaciones.btnShowMore') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </article>
    </slick>
  </section>
</template>
<script lang="js">
import Slick from 'vue-slick';
import { mapGetters } from 'vuex';

export default {
  name: 'slider-instalaciones',
  components: { Slick },
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        initialSlide: 0,
        autoplay: false,
        speed: 2000,
        autoplaySpeed: 5000,
      },
    }
  },
  computed: {
    ...mapGetters({
      precios: 'getPrecios'
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/parts/slider-instalaciones.vue